"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepositoryContext = void 0;
const client_core_1 = require("@sensenet/client-core");
const react_1 = require("react");
/**
 * Context that stores the current Repository instance
 */
exports.RepositoryContext = react_1.createContext(new client_core_1.Repository());
exports.RepositoryContext.displayName = 'RepositoryContext';
//# sourceMappingURL=repository.js.map